import type { ObPaymentPageViewFormType } from "../../obPaymentPage/obPaymentPageView/obPaymentPageViewStore";
import { defaultMaxAmount, validateAmount, validationViewPageConfig } from "../../obPaymentPage/validation";
import { normalizeValue } from "../../paymentLink/components/form/formStore";

/**
 * Today's max-amount message under Amount (spec 5.3), or undefined when the amount is within the
 * page's maximum. The "£" is hard-coded as today, whatever the currency (Q24).
 */
export function maxAmountMessage(maxAmount: Nullable<string>, amount: string): string | undefined {
  return validateAmount(maxAmount ?? undefined, amount) === "max"
    ? `* Sorry, our maximum for one payment is £${normalizeValue(maxAmount || defaultMaxAmount.toString())}`
    : undefined;
}

/**
 * Whether the pay buttons can be pressed (owner decision Q12): every `validationViewPageConfig`
 * rule passes and the amount is not over the page's maximum.
 *
 * Pure: it only reads `values`, unlike `Form.isValid()`, which writes the errors into the form and
 * so must not run during render. Read from an observer, it re-renders as the values change.
 */
export function isPayFormValid(values: ObPaymentPageViewFormType, maxAmount: Nullable<string>): boolean {
  const rulesPass = Object.entries(validationViewPageConfig).every(([field, { rules }]) => {
    const value: unknown = Reflect.get(values, field);
    return rules.every(({ check }) => check(value));
  });
  return rulesPass && maxAmountMessage(maxAmount, values.amount) === undefined;
}
